import { render, staticRenderFns } from "./participant-statistic.vue?vue&type=template&id=44571626&scoped=true&"
import script from "./participant-statistic.vue?vue&type=script&lang=js&"
export * from "./participant-statistic.vue?vue&type=script&lang=js&"
import style0 from "./participant-statistic.vue?vue&type=style&index=0&id=44571626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44571626",
  null
  
)

export default component.exports